module.exports = __webpack_public_path__ + "img/resource.db0f9044.svg";